import React from 'react';
import { reasons } from '../data/reasons';
export function WhyChooseUs() {
  return <section id="about" className="bg-sand py-20 lg:py-28" data-id="element-142" data-mp="13wxlvdfkzd6m">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-143" data-mp="13wfkk2e2a8ru">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-144" data-mp="q6lpv3fvkua7">
          <div data-id="element-145" data-mp="u75qigznqg13">
            <p className="text-[0.65rem] uppercase tracking-overline text-champagne-dark" data-id="element-146" data-mp="u6m52qast9ib">
              Why Choose Us
            </p>
            <h2 className="mt-5 text-3xl font-light leading-[1.15] tracking-[-0.02em] text-ink sm:text-[2.75rem]" data-id="element-147" data-mp="g6bdtm5ktswm">
              A standard of care that doesn&rsquo;t bend
            </h2>
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/4d3fccdc-f877-4a5e-bc96-9bdbb9ddb1ea.jpg" alt="Dr. Sara, board-certified plastic surgeon, in her Miami clinic" className="mt-10 hidden h-[420px] w-full object-cover lg:block" data-id="element-148" data-mp="78iy4gvy0j8p" />
            <p className="mt-6 hidden text-sm leading-[1.8] text-ink-soft lg:block" data-id="element-149" data-mp="25lrnd2nexgn1">
              Dr. Sara — Board-Certified Plastic Surgeon, Miami
            </p>
          </div>

          <ul className="grid gap-x-12 gap-y-10 border-t border-line pt-10 sm:grid-cols-2" data-id="element-150" data-mp="1iesit1q8jm20">
            {reasons.map((reason, index) => <li key={reason.title} data-id="element-151" data-mp="1x6auwofz4wg3" data-mpi={index}>
                <span className="block text-[0.7rem] tracking-[0.14em] text-champagne" data-id="element-152" data-mp="1s53p2uxe67c2">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-4 text-lg font-medium tracking-[-0.01em] text-ink" data-id="element-153" data-mp="zgppiaqnn2ye">
                  {reason.title}
                </h3>
                <p className="mt-3 text-[0.9rem] leading-[1.8] text-ink-soft" data-id="element-154" data-mp="1ef06qf1muxrw">
                  {reason.description}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}